import type { RouteLocation } from '#vue-router'

type NamedRoute = RouteLocation['name']

export default defineNuxtRouteMiddleware(async (to) => {
  const userStore = useUserStore()
  const { isAuthenticated } = useAuth()

  if (isAuthenticated.value && !userStore.user) {
    await userStore.fetchUser()
  }

  const isEpaperRegisterPage = (['epaper-registrierung', 'epaper-en-register'] as NamedRoute[]).includes(to.name)
  const isEpaperLoginPage = (['epaper-login', 'epaper-en-login'] as NamedRoute[]).includes(to.name)
  const isEpaperSubscribePage = (['epaper-abonnieren', 'epaper-en-subscribe'] as NamedRoute[]).includes(to.name)
  const isEpaperMagazinePage = (['epaper-magazine', 'epaper-en-magazine'] as NamedRoute[]).includes(to.name)
  const isEpaperMagazineArchive = (['magazin-archiviert', 'magazine-archives'] as NamedRoute[]).includes(to.name)

  if (isEpaperRegisterPage || isEpaperLoginPage) {
    if (userStore.isLoggedIn) {
      return customNavigateTo({
        name: userStore.isEpaperSubscribed ? 'epaper-magazine' : 'epaper-abonnieren',
      })
    }
  } else if (isEpaperSubscribePage) {
    if (userStore.isLoggedIn && userStore.isEpaperSubscribed) {
      return customNavigateTo({
        name: 'epaper-magazine',
      })
    } else if (!userStore.isLoggedIn) {
      return customNavigateTo({
        name: 'epaper',
      })
    }
  } else if (isEpaperMagazinePage) {
    if (userStore.isLoggedIn && !userStore.isEpaperSubscribed) {
      return customNavigateTo({
        name: 'epaper-abonnieren',
      })
    }
    else if (!userStore.isLoggedIn) {
      return customNavigateTo({
        name: 'epaper',
      })
    }
  } else if (isEpaperMagazineArchive && !userStore.isLoggedIn) {
    return customNavigateTo({
      name: 'epaper-login',
    })
  }
})
